import { render, staticRenderFns } from "./AdminSurveys.vue?vue&type=template&id=26381ae2"
import script from "./AdminSurveys.vue?vue&type=script&lang=ts"
export * from "./AdminSurveys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports